module.exports = __webpack_public_path__ + "static/media/c_logopng.6eede98f.png";